import { chain } from "./chain";
import { contract } from "./contract";

export const Explorer = () => {
  return (
    <iframe
      className="absolute top-0 right-0 w-[40vw] h-[100vh] border-none bg-black"
      src={`${chain.blockExplorers.worldsExplorer.url}/${contract.address}/observe`}
    />
  );
};
